<template>
	<AsiCardDetail :title="$t('mailTemplate.bulkOfferRequest')" no-bottom-margin unwrapped>
		<MailTemplateDetailEntry v-for="template in templates" :key="template.id"
		                         :mail-template="template" :readonly="readonly"
		                         @save="save" @delete="emitDelete">
			<template v-slot:specificInfos>
				<MailTemplateInfoCard :title="$t('mailTemplate.terms.bulkOfferRequestInformations')"
				                      :infos="bulkOfferRequestInfos"
				                      :icon="icons.mail" no-bottom-margin/>
			</template>
		</MailTemplateDetailEntry>
	</AsiCardDetail>
</template>

<script lang="ts">
	import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
	import MailTemplateDetailEntry from "@/components/mail-template/MailTemplateDetailEntry.vue";
	import MailTemplateInfoCard from "@/components/mail-template/MailTemplateInfoCard.vue";
	import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
	import {IMailTemplateAdminListEntry} from "@/models/mail-template/MailTemplateAdminModels";
	import Icon from "@/plugins/icons";
	import MailTemplateInfo from "@/models/mail-template/MailTemplateInfo";

	@Component({
		components: {AsiCardDetail, MailTemplateInfoCard, MailTemplateDetailEntry}
	})
	export default class SettingsCardMailTemplatesBulkOfferRequest extends Vue {

		@Prop({type: Array, required: true})
		public templates!: IMailTemplateAdminListEntry[];

		@Prop({type: Boolean, default: false})
		public readonly!: boolean;

		private icons = Icon;

		private get bulkOfferRequestInfos(): MailTemplateInfo[] {
			return [
				new MailTemplateInfo('{company}', 'mailTemplate.placeholders.bulkOfferRequest.company'),
				new MailTemplateInfo('{street}', 'mailTemplate.placeholders.bulkOfferRequest.street'),
				new MailTemplateInfo('{houseNumber}', 'mailTemplate.placeholders.bulkOfferRequest.houseNumber'),
				new MailTemplateInfo('{zip}', 'mailTemplate.placeholders.bulkOfferRequest.zip'),
				new MailTemplateInfo('{city}', 'mailTemplate.placeholders.bulkOfferRequest.city'),
				new MailTemplateInfo('{email}', 'mailTemplate.placeholders.bulkOfferRequest.email'),
				new MailTemplateInfo('{phone}', 'mailTemplate.placeholders.bulkOfferRequest.phone'),
				new MailTemplateInfo('{itemName}', 'mailTemplate.placeholders.bulkOfferRequest.itemName'),
				new MailTemplateInfo('{itemNumber}', 'mailTemplate.placeholders.bulkOfferRequest.itemNumber'),
				new MailTemplateInfo('{alternativeItemNumber}', 'mailTemplate.placeholders.bulkOfferRequest.alternativeItemNumber'),
				new MailTemplateInfo('{quantity}', 'mailTemplate.placeholders.bulkOfferRequest.quantity'),
				new MailTemplateInfo('{unit}', 'mailTemplate.placeholders.bulkOfferRequest.unit'),
				new MailTemplateInfo('{additionalScaleQuantity1}', 'mailTemplate.placeholders.bulkOfferRequest.additionalScaleQuantity1'),
				new MailTemplateInfo('{additionalScaleQuantity2}', 'mailTemplate.placeholders.bulkOfferRequest.additionalScaleQuantity2'),
				new MailTemplateInfo('{remark}', 'mailTemplate.placeholders.bulkOfferRequest.remark'),
				new MailTemplateInfo('{cartId}', 'mailTemplate.placeholders.bulkOfferRequest.cartId'),
				new MailTemplateInfo('{positionId}', 'mailTemplate.placeholders.bulkOfferRequest.positionId'),
			];
		}

		@Emit('save')
		public save(): void {
			return;
		}

		@Emit('delete')
		public emitDelete(id: string): string {
			return id;
		}
	}
</script>
